import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { CategoryService } from 'src/app/core/services/category.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {
  isArabic: any;
  message: string = '';
  messageOne: string = '';
  redirectTo: string = '';
  cancelButton!: boolean;
  external!: boolean;
  arabicMessage: string = '';


  constructor(private storageService: StorageService, public bsModalRef: BsModalRef, private route: Router,
    private categoryService: CategoryService) { }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
  }

  closeNotification(isOkay?: boolean) {
    if (isOkay && this.cancelButton) {
      this.bsModalRef.hide();
      this.categoryService.setConfirmation('ok');
    } else {
      if (this.bsModalRef) {
        this.bsModalRef.hide();
        if (this.external) {
          window.open(this.redirectTo, '_self');
        } else if (this.redirectTo != '') {
          this.route.navigate([this.redirectTo]);
          // if(this.redirectTo == 'login') {
          //   window.location.reload();
          // }
        }
      }
    }
  }

}
